export default __webpack_public_path__ + "static/media/beans.13ad1970.png";